import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import _ from 'lodash';
import queryString from 'query-string';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
// import moment from 'moment';
import * as actions from '../actions';
import * as c from '../constants';
import history from '../../../../history';

const BPLSReports = ({ getList, list, isLoading, pager }) => {
  const query = queryString.parse(window.location.search);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const [formData, setFormData] = useState({
    bin: '',
    kind_of_ownership: '',
    pre_registration_date_from: '',
    pre_registration_date_to: '',
    registration_status: '',
  });
  const syncFilters = params => {
    return history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(params),
    });
  };

  const handleDateChange = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleChangePage = page => {
    getList({ ...formData, page });
    syncFilters({ ...formData, page });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    syncFilters({ ...formData, [e.target.name]: e.target.value });
  };

  const selectOptions = c.REGISTRATION_STATUS.map(x => ({
    label: x.label,
    value: x.value,
  }));

  const handleChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
    syncFilters({ ...formData, [key]: e ? e.value : '' });
  };

  useEffect(() => {
    getList({
      ...formData,
      // ...queryString.parse(window.location.search),
    });
  }, []);

  const onSearch = e => {
    e.preventDefault();
    getList({
      ...formData,
    });
  };

  const onClear = e => {
    e.preventDefault();
    setFormData({
      pre_registration_date_from: '',
      pre_registration_date_to: '',
      kind_of_ownership: '',
      bin: '',
      registration_status: ''
    });
    syncFilters({
      pre_registration_date_from: '',
      pre_registration_date_to: '',
      kind_of_ownership: '',
      bin: '',
      registration_status: ''
    });
    getList({});
    history.replace({ pathname: window.location.pathname });
  };

  const getReports = () => {
    const path = `${process.env.REACT_APP_WS}api/v1/bpls/administrator/report/pre_registrations/export_csv`;
    const params = queryString.stringify({
      ...queryString.parse(window.location.search),
      ...formData,
      bearer_token: token,
      email: _.get(authProfile, 'email'),
    });
    return `${path}?${params}`;
  };

  return (
    <div className="module-inner">
      <div className="report-module-nav mb-3">
        <div className="col-12">
          <form onSubmit={onSearch}>
            <div className="row mt-2">
              <div className="col-3">
                <div className="form-group">
                  <label className="label-reports">Registration Status</label>
                  <Select
                    name="registration_status"
                    placeholder="Select Status"
                    onChange={handleChangeSelect('registration_status')}
                    options={selectOptions}
                    value={
                      query.registration_status
                        ? {
                          value: query.registration_status,
                          label: query.registration_status,
                        }
                        : { value: '', label: 'ALL' }
                    }
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="form-group">
                  <label className="label-reports">Kind of Ownership</label>
                  <Select
                    name="kind_of_ownership"
                    placeholder="Select Module Type"
                    onChange={handleChangeSelect('kind_of_ownership')}
                    options={c.KIND_OF_OWNERSHIP}
                    value={
                      query.kind_of_ownership
                        ? {
                          value: query.kind_of_ownership,
                          label: query.kind_of_ownership,
                        }
                        : { value: '', label: 'ALL' }
                    }
                  />
                </div>
              </div>
              <div className="form-input-group col-3">
                <label className="label-reports">Date From</label>
                <DateInputPicker
                  className="full-input"
                  onChange={handleDateChange('pre_registration_date_from')}
                  value={_.get(formData, 'pre_registration_date_from') || ''}
                />
              </div>
              <div className="form-input-group col-3">
                <label className="label-reports">Date To</label>
                <DateInputPicker
                  className="full-input"
                  onChange={handleDateChange('pre_registration_date_to')}
                  value={_.get(formData, 'pre_registration_date_to') || ''}
                />
              </div>
              <div className="col-3 pr-0">
                <div className="form-group">
                  <label className="label-reports">BIN</label>
                  <input
                    className="form-control"
                    name="bin"
                    onChange={onChange}
                    value={query.bin || ''}
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-6 pr-0">
                <div className="form-group">
                  <button type="submit" className="btn btn-link button-filter">
                    <i className="fas fa-filter" /> &nbsp;&nbsp;Filter
                  </button>
                  &nbsp;
                  <button
                    onClick={onClear}
                    type="button"
                    className="btn btn-link button-clear"
                  >
                    <i className="fas fa-times" /> &nbsp;&nbsp; Clear
                  </button>
                </div>
              </div>
            </div>
            <div className="col-6 pr-0 d-flex ml-auto">
              <div className="ml-auto">
                <div className="form-group">
                  <label className="label-reports">Total Registered: &nbsp;</label>
                  <input
                    name="q"
                    disabled
                    value={_.get(pager, 'total') || ''}
                  />
                </div>
              </div>
            </div>
          </form>
          <div className="row bg-white pr-3 py-2 mb-2">
            <div className="ml-auto">
              <div className="">
                <a
                  href={getReports()}
                  className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary "
                  style={{ color: 'white' }}
                >
                  <i className="fas fa-cloud-download-alt mr-2" />
                  Download
                </a>
              </div>
            </div>
          </div>
          {isLoading ? (
            <div
              className="loading d-flex text-center justify-content-center align-items-center"
              style={{ height: '500px' }}
            >
              <div className="spinner text-center ">
                <span className="fas fa-5x fa-spin fa-spinner" />
              </div>
            </div>
          )
            : (
              <div className="table-responsive">
                <table className="table table-striped table-sm table-bordered table-hover" style={{ width: '130%' }}>
                  <thead className="table-header text-center">
                    <tr>
                      <th style={{ width: '15%' }}>BIN</th>
                      <th>BUSINESS NAME</th>
                      <th>OWNERS NAME</th>
                      <th>KIND OF OWNERSHIP</th>
                      <th>MOBILE NO</th>
                      <th>TELEPHONE NO</th>
                      <th>EMAIL</th>
                      <th>SEC NO</th>
                      <th style={{ width: '15%' }}>TIN NO</th>
                      <th style={{ width: '15%' }}>DTI NO</th>
                      <th style={{ width: '20%' }}>ADDRESS</th>
                      <th style={{ width: '10%' }}>REGISTERED TAXPAYER</th>
                      <th>TAXPAYER MOBILE NO</th>
                      <th>STATUS</th>
                      <th style={{ width: '15%' }}>DATE OF REGISTRATION</th>
                    </tr>
                  </thead>
                  <tbody className="table-details">
                    {list.map(item => {
                      return (
                        <tr key={item.id}>
                          <td>
                            {_.get(item, 'attributes.bin') || '---'}
                          </td>
                          <td>
                            {_.get(
                              item,
                              'attributes.business_name'
                            ) || '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.owners_display_name') || ' '}
                          </td>
                          <td>
                            {_.get(item, 'attributes.kind_of_ownership') ||
                              '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.cellphone_no') ||
                              '---'}
                          </td>

                          <td>{_.get(item, 'attributes.telephone_no') || '---'}</td>
                          <td>
                            {_.get(item, 'attributes.email_address') ||
                              '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.sec_no') ||
                              '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.tin_no') ||
                              '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.dti_no') ||
                              '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.display_address') ||
                              '---'}
                          </td>
                          <td>
                            {_.get(item, 'included.taxPayer.attributes.display_name') ||
                              '---'}
                          </td>
                          <td>
                            {_.get(item, 'included.taxPayer.attributes.mobile_number') ||
                              '---'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.terms_and_conditions_pre_registration') ?
                              'COMPLETED' : 'PENDING'}
                          </td>
                          <td>
                            {_.get(item, 'attributes.pre_registration_date') ||
                              '---'}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          <div className="list-pagination">
            {pager.total_pages > 1 ? (
              <div className="d-flex justify-content-center text-center align-item-center">
                <Pagination data={pager} onChange={handleChangePage} />
              </div>
            ) : (
                ''
              )}
          </div>
        </div>
      </div>
    </div>
  );
};

BPLSReports.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  list: _.get(api, `${c.LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.LIST) > -1,
  pager: _.get(api, `${c.LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BPLSReports);
